/* eslint-disable jsx-a11y/aria-proptypes */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { Button, Col, Row, Tooltip, OverlayTrigger } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
  toAbsoluteUrl,
} from "../../../../_metronic/_helpers";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  formatDate,
  sizePerPageList,
  showDialog,
  StatusFormatter,
  formatCurrency,
} from "../../../utility";
import { setRtv } from "./withrtvSlice";
import SVG from "react-inlinesvg";

export const WithRtvTable = ({
  data,
  page,
  sizePerPage,
  onTableChange,
  totalSize,
  loading,
  rtv,
  deleteRow,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [onSelectAll, setOnSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [tableData, setTableData] = useState(data);

  useEffect(() => {
    // Add number
    const pageBefore = sizePerPage * (page - 1);
    const initData = data.map((item, index) => {
      return {
        ...item,
        no: index + 1 + pageBefore,
        returnId: rtv.returnId,
        rtvNo: rtv.rtvNo,
        rtvDate: rtv.rtvDate,
        rtvReceivingDate: rtv.rtvReceivingDate,
        remarksRtv: rtv.remarksRtv,
      };
    });
    setTableData(initData);
  }, [data, sizePerPage, page]);

  //ref to bind this fuker
  //https://stackoverflow.com/questions/59121058/react-hook-updates-parent-state-a-step-behind
  const handleDeleteChangeData = (column) => {
    const idColumn = column.uuid;
    setUid(idColumn);
  };

  const [uid, setUid] = useState("");

  useEffect(() => {
    deleteRow(uid, data);
  }, [uid]);
  // this fuker bug stop here

  const StatusCrpFormatter = (cellContent, row) => {
    let label = "";
    if (cellContent === "Y") {
      label = "Within CRP";
    } else if (cellContent === "N") {
      label = "Non CRP";
    } else if (cellContent === "N/A") {
      label = "N/A";
    }

    return <span>{label}</span>;
  };

  const options = {
    showTotal: true,
    totalSize: tableData.length,
    sizePerPageList: sizePerPageList,
  };

  const columns = [
    {
      text: "Action",
      dataField: "action",
      editable: false,

      formatter: (cell, column, formatExtraData) => {
        return (
          <OverlayTrigger
            overlay={<Tooltip id="products-delete-tooltip">Delete</Tooltip>}
          >
            <div
              className="btn btn-icon btn-light btn-hover-danger btn-sm"
              onClick={() => handleDeleteChangeData(column, cell)}
            >
              <span className="svg-icon svg-icon-md svg-icon-danger">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")}
                />
              </span>
            </div>
          </OverlayTrigger>
        );
      },
    },
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Invoice Ref Num",
      dataField: "invoiceNo",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "invoice item number",
      dataField: "line",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Invoice Ref Date",
      dataField: "transactionDate",
      sort: true,
      formatter: formatDate,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "tax Invoice Ref No",
      dataField: "taxInvoiceNo",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "PO Ref Num",
      dataField: "po",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Material",
      dataField: "materialCode",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Material Desc",
      dataField: "materialName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },

    {
      text: "Client Code",
      dataField: "clientCode",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Client Name",
      dataField: "clientName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Batch",
      dataField: "batch",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Exp Date",
      dataField: "expiredDate",
      sort: true,
      formatter: formatDate,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Avail Qty",
      dataField: "availableQty",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },

    {
      text: "Net Sales",
      dataField: "netPrice",
      formatter: formatCurrency,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Customer Block",
      dataField: "customerBlocked",
      formatter: StatusFormatter,
      align: "center",
    },
    {
      text: "Material Block",
      dataField: "blocked",
      formatter: StatusFormatter,
      align: "center",
    },
    {
      text: "Material Exclusion",
      dataField: "materialExcluded",
      formatter: StatusFormatter,
      align: "center",
    },
    {
      text: "CRP/RGP",
      dataField: "crprgp",
      formatter: StatusCrpFormatter,
      align: "center",
    },
    {
      text: "FullBox",
      dataField: "nonFraction",
      formatter: StatusFormatter,
    },
    {
      text: "NRA",
      dataField: "nra",
      formatter: StatusFormatter,
    },
  ];

  return (
    <>
      <BootstrapTable
        remote
        wrapperClasses="table-responsive"
        classes="table table-head-custom table-vertical-center overflow-hidden"
        bootstrap4
        bordered={false}
        keyField="uuid"
        data={tableData}
        columns={columns}
        pagination={paginationFactory(options)}
        onTableChange={onTableChange}
        hover
      >
        <PleaseWaitMessage entities={loading ? null : tableData} />
        <NoRecordsFoundMessage entities={loading ? null : tableData} />
      </BootstrapTable>

      {/* Footer */}
      <Row className="mt-4 mb-5">
        <Col sm={1}>
          <Button
            variant="success"
            onClick={() => {
              dispatch(setRtv(tableData));
              history.push(`/new-return/with-rtv/detail`);
            }}
          >
            Next
          </Button>
        </Col>
        <Col sm={1}>
          <Button
            variant="outline-danger"
            onClick={() => history.push("/new-return/with-rtv")}
          >
            Back
          </Button>
        </Col>
      </Row>
    </>
  );
};
